import { verifyAuthLink } from '@/lib/server/verifyAuthLink.tsx';
import { resetAuthUser } from '@/routes/admin.tsx';
import type { EmailOtpType } from '@supabase/supabase-js';
import { createFileRoute, redirect } from '@tanstack/react-router';

const OTP_TYPES: EmailOtpType[] = ['signup', 'invite', 'magiclink', 'recovery', 'email_change', 'email'];

type ConfirmSearch = {
  token_hash?: string;
  type?: EmailOtpType;
  code?: string;
};

export const Route = createFileRoute('/auth/confirm')({
  preload: false,
  validateSearch: (search: Record<string, unknown>): ConfirmSearch => ({
    token_hash: typeof search.token_hash === 'string' ? search.token_hash : undefined,
    type: OTP_TYPES.includes(search.type as EmailOtpType) ? (search.type as EmailOtpType) : undefined,
    code: typeof search.code === 'string' ? search.code : undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps }) => {
    const { error } = await verifyAuthLink({ data: deps });
    resetAuthUser(queryClient);

    if (error) {
      throw redirect({ to: '/sign-in', search: { error: 'invalid_link' } });
    }

    // Zonder type (PKCE-code) komt de link uit de resetmail.
    switch (deps.type ?? 'recovery') {
      case 'recovery':
        throw redirect({ to: '/reset-password' });
      case 'email_change':
        throw redirect({ to: '/admin/account' });
      default:
        throw redirect({ to: '/admin' });
    }
  },
});
